import { render } from "./DettaglioVociSpesaBusinessUnitsIva.vue?vue&type=template&id=420fd24e&ts=true"
import script from "./DettaglioVociSpesaBusinessUnitsIva.vue?vue&type=script&lang=ts"
export * from "./DettaglioVociSpesaBusinessUnitsIva.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__